import { Button, Popconfirm } from 'antd'
import React, { FunctionComponent, memo, useCallback, useMemo } from 'react'

import { useDeleteZustavateRecord } from '../../utils/useDeleteZustavateRecord'
import { ZustavateTableItem } from '../../utils/useZustavateData'

export interface ZustavateRecordDeleteProps {
  record: ZustavateTableItem
  onDelete?: () => void
}

export const ZustavateRecordDelete: FunctionComponent<ZustavateRecordDeleteProps> =
  memo(({ record, onDelete }) => {
    const { id: recordId } = record
    const { deleteRecord, isDeleting } = useDeleteZustavateRecord()

    const handleConfirm = useCallback(async () => {
      const success = await deleteRecord(recordId)
      if (success) {
        onDelete?.()
      }
    }, [deleteRecord, onDelete, recordId])

    const buttonProps = useMemo(
      () => ({
        ok: {
          loading: isDeleting,
          danger: true,
          size: 'middle' as const,
        },
        cancel: {
          size: 'middle' as const,
        },
      }),
      [isDeleting]
    )

    return (
      <Popconfirm
        title="Smazat záznam"
        description="Opravdu chcete smazat tento záznam?"
        placement="rightTop"
        onConfirm={handleConfirm}
        okText="Smazat"
        cancelText="Zrušit"
        okButtonProps={buttonProps.ok}
        cancelButtonProps={buttonProps.cancel}
      >
        <Button size="small" type="link" danger loading={isDeleting}>
          Smazat
        </Button>
      </Popconfirm>
    )
  })
